import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useRef, useEffect } from 'react'
import styles from './CreateDocModal.module.scss'

const BUTTONS = [
  { cmd: 'bold',          label: 'B',  title: "Жирный (Ctrl+B)",          style: { fontWeight: 700 } },
  { cmd: 'italic',        label: 'I',  title: "Курсив (Ctrl+I)",          style: { fontStyle: 'italic' } },
  { cmd: 'underline',     label: 'U',  title: "Подчёркнутый (Ctrl+U)",    style: { textDecoration: 'underline' } },
  { sep: true },
  { cmd: 'justifyLeft',   label: '⬛', title: "По левому краю" },
  { cmd: 'justifyCenter', label: '▬',  title: "По центру" },
  { cmd: 'justifyFull',   label: '≡',  title: "По ширине" },
  { sep: true },
  { cmd: 'insertUnorderedList', label: '•', title: "Маркерный список" },
  { cmd: 'insertOrderedList',   label: '1.', title: "Нумерованный список" },
  { sep: true },
  { cmd: 'indent',   label: '→', title: "Увеличить отступ" },
  { cmd: 'outdent',  label: '←', title: "Уменьшить отступ" },
]

export default function DocEditorSection({
  mode, setMode,
  content, setContent,
  mainFile, setMainFile,
  existingFileName,
}) {
  useInterfaceLanguage();
  const editorRef = useRef(null)
  const initialized = useRef(false)
  const initialContent = useRef(content)

  useEffect(() => {
    if (editorRef.current && !initialized.current) {
      editorRef.current.innerHTML = initialContent.current || ''
      initialized.current = true
    }
  }, [])

  function execCmd(cmd) {
    editorRef.current?.focus()
    document.execCommand(cmd, false, null)
  }

  function handleEditorInput() {
    if (editorRef.current) {
      setContent(editorRef.current.innerHTML)
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Tab') {
      e.preventDefault()
      document.execCommand('insertHTML', false, '\u00a0\u00a0\u00a0\u00a0')
    }
    // Allow Enter to work naturally via browser default
  }

  function handleFileChange(e) {
    const file = e.target.files[0]
    if (!file) return
    if (file.type !== 'application/pdf') {
      alert(tr("Допускается только PDF"))
      return
    }
    setMainFile(file)
  }

  return (
    <div className={styles.editorSection}>
      {/* Mode toggle */}
      <div className={styles.editorToggle}>
        <button
          type="button"
          className={`${styles.modeBtn} ${mode === 'text' ? styles.modeActive : ''}`}
          onClick={() => setMode('text')}
        >{tr("✏️ Текст")}</button>
        <button
          type="button"
          className={`${styles.modeBtn} ${mode === 'file' ? styles.modeActive : ''}`}
          onClick={() => setMode('file')}
        >{tr("📎 PDF-файл")}</button>
      </div>

      {mode === 'text' ? (
        <div className={styles.richEditorWrap}>
          <div className={styles.toolbar}>
            {BUTTONS.map((b, i) =>
              b.sep
                ? <span key={i} className={styles.sep} />
                : (
                  <button
                    key={b.cmd}
                    type="button"
                    className={styles.fmtBtn}
                    style={b.style}
                    title={tr(b.title)}
                    onMouseDown={e => { e.preventDefault(); execCmd(b.cmd) }}
                  >
                    {tr(b.label)}
                  </button>
                )
            )}
          </div>
          <div
            ref={editorRef}
            className={styles.richEditor}
            contentEditable
            suppressContentEditableWarning
            onInput={handleEditorInput}
            onKeyDown={handleKeyDown}
            data-placeholder={tr("Введите текст документа…")}
            dir="ltr"
            spellCheck
          />
        </div>
      ) : (
        <div className={styles.fileUploadZone}>
          {mainFile ? (
            <div className={styles.filePreview}>
              <span className={styles.fileIcon}>📄</span>
              <div>
                <span className={styles.fileName}>{tr(mainFile.name)}</span>
                <span className={styles.fileSize}>{(mainFile.size / 1024).toFixed(0)}{tr(" КБ")}</span>
              </div>
              <button
                type="button"
                className={styles.removeFileBtn}
                onClick={() => setMainFile(null)}
              >
                ×
              </button>
            </div>
          ) : existingFileName ? (
            <div className={styles.filePreview}>
              <span className={styles.fileIcon}>📄</span>
              <div>
                <span className={styles.fileName}>{tr(existingFileName)}</span>
                <span className={styles.fileSize}>{tr("текущий файл — нажмите чтобы заменить")}</span>
              </div>
              <label style={{ cursor: 'pointer', padding: '4px 10px', background: "var(--theme-info-soft, #e2e8f0)", borderRadius: 6, fontSize: 12 }}>{tr("Заменить")}<input type="file" accept="application/pdf" onChange={handleFileChange} hidden />
              </label>
            </div>
          ) : (
            <label className={styles.dropLabel}>
              <span className={styles.dropIcon}>📎</span>
              <strong>{tr("Выберите PDF-файл")}</strong>
              <span>{tr("или перетащите сюда")}</span>
              <input type="file" accept="application/pdf" onChange={handleFileChange} hidden />
            </label>
          )}
        </div>
      )}
    </div>
  )
}
